import { useCallback, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getPaymentProvidersComparison } from 'commons/services/paymentProviders/paymentProvidersService';
import {
  PaymentProviderComparisonResult,
  PaymentProvidersComparisonParams,
} from 'commons/types';

const HTTP_STATUS_NOT_FOUND = 404;

function getErrorKey(error: unknown): string | null {
  if (!error) return null;
  if (
    axios.isAxiosError(error) &&
    error.response?.status === HTTP_STATUS_NOT_FOUND
  ) {
    return 'errorNoRatesFound';
  }
  return 'error';
}

export const useFeeCalculatorResults = () => {
  const [params, setParams] = useState<PaymentProvidersComparisonParams | null>(
    null,
  );

  const { data, isFetching, error } = useQuery<
    PaymentProviderComparisonResult[]
  >({
    queryKey: ['payment-providers-comparison', params],
    queryFn: () => getPaymentProvidersComparison(params!),
    enabled: !!params,
  });

  const errorKey = useMemo(() => getErrorKey(error), [error]);

  const fetchFeeCalculatorResults = useCallback(
    (newParams: PaymentProvidersComparisonParams) => {
      setParams(newParams);
    },
    [],
  );

  const resetFeeCalculatorResults = useCallback(() => {
    setParams(null);
  }, []);

  return {
    results: data,
    isLoading: isFetching,
    errorKey,
    fetchFeeCalculatorResults,
    resetFeeCalculatorResults,
  };
};
